// @ts-nocheck
import React, { useState, useEffect } from 'react';
import FormikControl from '../../components/Formik/FormikControl';
import { Form, Formik } from 'formik';
import CustomBtnSelect from '../../components/Formik/CustomBtnSelect';
import CarrierAutocomplete from '../../components/CarrierAutocomplete';
import { Button } from '@mui/material';
import ImageUploadField from './ImageUploadField';
import { toast } from 'react-toastify';

type Props = {
  insuranceInfo: any;
  loadingState: boolean;
  onConfirm: ({
    frontFilePath,
    backFilePath,
    details,
  }: {
    frontFilePath: File | null;
    backFilePath: File | null;
    details: any;
  }) => void;
  onOpenSMS: () => void;
  formDetails: any;
  setFormDetails: (d: any) => void;
};

const relationships = ['Self', 'Spouse', 'Parent', 'Child', 'Other'];
const relationshipOpts = relationships.map((option) => ({
  key: option,
  value: option,
}));

const defaultDetails = {
  insuranceCarrier: '',
  insuredID: '',
  planNumber: '',
  relationship: '',
  subscriberName: '',
  effectiveDate: '',
  frontPhoto: '',
  backPhoto: '',
};

const ConfirmDetails = ({
  insuranceInfo = {},
  loadingState,
  onConfirm,
  onOpenSMS,
  formDetails,
  setFormDetails,
}: Props) => {
  const [details, setDetails] = useState(formDetails || defaultDetails);

  const [images, setImages] = useState({
    front: { file: null, previewUrl: '' },
    back: { file: null, previewUrl: '' },
  });

  const handleDetailsChange = (e: any, key: any) => {
    const value = key === 'effectiveDate' ? e.formattedValue : e.target.value;
    const updated = {
      ...details,
      [key]: value,
    };
    setDetails(updated);
    setFormDetails(updated);
  };

  const handleChangeType = (value) => {
    const updated = {
      ...details,
      medicaid: value === 'Medicaid',
      medicarePartB: value === 'Medicare Part B',
    };
    setDetails(updated);
    setFormDetails(updated);
  };

  const handleUpload = (side: 'front' | 'back', file: File) => {
    const previewUrl = URL.createObjectURL(file);

    setImages((prev) => ({
      ...prev,
      [side]: {
        file,
        previewUrl,
      },
    }));
  };

  useEffect(() => {
    if (insuranceInfo) {
      setDetails(insuranceInfo);
      setFormDetails(insuranceInfo);
      setImages({
        front: {
          file: null,
          previewUrl: insuranceInfo.frontPhoto || '',
        },
        back: {
          file: null,
          previewUrl: insuranceInfo.backPhoto || '',
        },
      });
    }
  }, [insuranceInfo]);

  return (
    <>
      <div className="form-container">
        <p className="--bold">Insurance Record</p>
        <Formik initialValues={{}}>
          <Form>
            <CarrierAutocomplete
              style={{
                backgroundColor: '#f4f6fa',
                borderRadius: '10px',
                padding: '10px',
                width: '100%',
                textAlign: 'center',
              }}
              className="confirm-details-input"
              value={details.insuranceCarrier}
              onChange={(value) =>
                handleDetailsChange({ target: { value } }, 'insuranceCarrier')
              }
              topLabel={true}
              required
            />
            <FormikControl
              className="confirm-details-input"
              control="input"
              type="text"
              name="insuredID"
              placeholder="Insurance ID"
              value={details.insuredID}
              onChange={(e) => handleDetailsChange(e, 'insuredID')}
              showErrorMsg={false}
              label="Insurance ID"
            />
            <FormikControl
              className="confirm-details-input"
              control="input"
              type="text"
              name="planNumber"
              placeholder="Group Number"
              value={details.planNumber}
              onChange={(e) => handleDetailsChange(e, 'planNumber')}
              showErrorMsg={false}
              label="Group Number"
            />
            <FormikControl
              className="confirm-details-input"
              control="input"
              type="text"
              name="subscriberName"
              placeholder="Policy Holder Name"
              value={details.subscriberName}
              onChange={(e) => handleDetailsChange(e, 'subscriberName')}
              showErrorMsg={false}
              label="Policy Holder Name"
            />
            <FormikControl
              className="confirm-details-input"
              control="select"
              name="relationship"
              expanding={true}
              showErrorMsg={false}
              onChange={(e) => handleDetailsChange(e, 'relationship')}
              label="Relationship to Policy Holder"
              options={[
                {
                  key: 'Relation to Policy Holder',
                  value: '',
                  disabled: true,
                },
                ...relationshipOpts,
              ]}
            />
            <FormikControl
              className="confirm-details-input"
              control="input"
              format="##/##/####"
              formatType="date"
              value={details.effectiveDate}
              onChange={(v) => handleDetailsChange(v, 'effectiveDate')}
              name="effectiveDate"
              placeholder="MM/DD/YYYY"
              label="Effective Date of Coverage"
              showErrorMsg={false}
            />
            <CustomBtnSelect
              label="Is this card Medicare Part B or Medicaid?"
              persist={true}
              options={['Medicaid', 'Medicare Part B', 'Neither']}
              selected={
                insuranceInfo.medicaid
                  ? 'Medicaid'
                  : insuranceInfo.medicarePartB
                  ? 'Medicare Part B'
                  : 'Neither'
              }
              onClick={handleChangeType}
            />
            <ImageUploadField
              label="Insurance Card Images"
              frontPhoto={images.front.previewUrl || insuranceInfo.frontPhoto}
              backPhoto={images.back.previewUrl || insuranceInfo.backPhoto}
              onUploadFront={(file) => handleUpload('front', file)}
              onUploadBack={(file) => handleUpload('back', file)}
              onOpenSMS={onOpenSMS}
            />
          </Form>
        </Formik>
      </div>

      <Button
        variant="contained"
        onClick={() => {
          onConfirm({
            frontFilePath: images.front.file,
            backFilePath: images.back.file,
            details,
          });
        }}
        sx={{ width: 'fit-content', margin: 'auto', marginTop: 0.5 }}
      >
        Save
      </Button>
    </>
  );
};

export default ConfirmDetails;